module.exports = __webpack_public_path__ + "media/images/icons/gift-b608d1ffc46f36bdb4848ec36ec23c28.svg";